import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DocumentsManager from "./DocumentsManager";
import axios from "axios";

const AdminDocumentsPage = () => {
    const { userId } = useParams();
    const navigate = useNavigate();
    const [userName, setUserName] = useState("");

    useEffect(() => {
        const fetchUserName = async () => {
            const token = localStorage.getItem("adminToken");
            if (!token) {
                navigate("/admin-login");
                return;
            }
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/auth/user/${userId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (response.data?.user) {
                    setUserName(response.data.user.name);
                }
            } catch (err) {
                console.error("Failed to fetch user info", err);
            }
        };
        fetchUserName();
    }, [userId, navigate]);

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-dark-900 p-4 sm:p-6 lg:p-8">
            <div className="max-w-7xl mx-auto">
                <DocumentsManager 
                    userId={userId} 
                    userName={userName} 
                    hideBackButton={false}
                />
            </div>
        </div>
    );
};

export default AdminDocumentsPage;